module.exports = __webpack_public_path__ + "img/white-arrow.3134e3b2.svg";